module.exports = __webpack_public_path__ + "img/bank-back-arrow.ae01c915.svg";